export enum SizeType {
  SMALL = "sm",
  MEDIUM = "md",
  LARGE = "lg",
}

export enum ButtonColors {
  DEFAULT = "default",
  PRIMARY = "primary",
  SUCCESS = "success",
  DANGER = "danger",
  TRANSPARENT = "transparent",
  EARTH = "earth",
}

export enum ButtonVariants {
  FILL = "fill",
  GHOST = "ghost",
}

export enum CheckboxColor {
  DEFAULT = "default",
  SUCCESS = "success",
  DANGER = "danger",
}

export enum WalletEnum {
  CREDIT = "credit",
  BONUS = "bonus",
  REVENUE = "revenue",
}

export enum PaymentMethodProviderEnum {
  BankTransfer = "bank-transfer",
  OnlinePayment = "online-payment",
}

export enum TransactionTypeEnum {
  Deposit = "deposit",
  Withdraw = "withdraw",
}

export enum CurrencyEnum {
  THB = "THB",
  VND = "VND",
}

export enum RegionEnum {
  US = "us",
  VN = "vn",
  TH = "th",
  CN = "cn",
}

export const MoneyFormat = "0,0.[00]";
